export const SET_DAYS = 'SET_DAYS'
export const SET_FILTER = 'SET_FILTER'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_DATA = 'SET_DATA'
export const RESET_MODULE_STATE = 'RESET_MODULE_STATE'
export const SET_END_DATE = 'SET_END_DATE'
export const SET_START_DATE = 'SET_START_DATE'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_TYPE_BY = 'SET_TYPE_BY'
export const SET_BREAKDOWN_SUMMARY = 'SET_BREAKDOWN_SUMMARY'

export const SESSION_DAYS = 'dashboard/days'
export const SESSION_FILTER = 'dashboard/filter'
export const SESSION_PAGE_SIZE = 'dashboard/pageSize'
export const SESSION_SEARCH_TERM = 'dashboard/searchTerm'
export const SESSION_START_DATE = 'dashboard/startDate'
export const SESSION_END_DATE = 'dashboard/endDate'

export const DASHBOARD_DATA = 'DASHBOARD_DATA'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js